import { yup } from '@guiker/yup-util'

export const documentSchema = yup.object({})
